import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MonacoCodeEditorComponent, ChangeInfo, IClass } from '@farris/ide-code-editor';
import { ComponentCodeService, ModificationInfo } from './service/component-code.service';
// import { ComponentDesigner } from './interface/component-designer';
// import { ToolButtonService } from './service/tool-button.service';
import { SaveResult } from './types';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
// import { map, switchMap } from 'rxjs/operators';
// import { MetadataDto } from '@gsp-lcm/metadata-selector';
// import { ComponentMetadataService } from './service/component-metadata.service';
import { LogUtil } from './utils/log.util';
import { MessageNotifyService, NotifyType } from './service/message-notify.service';
import { LoadingService } from '@farris/ui-loading';
import { MessagerService } from '@farris/ui-messager';

declare const System: any;
@Component({
  selector: 'comp-code-editor',
  templateUrl: './comp-code-editor.component.html'
})
export class CompCodeEditorComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  /** æä»¶ä»£ç æä»¶è·¯å¾ï¼ä¸ä¼ å¥æ¶æ ¹æ®åæ°æ®è·¯å¾è·å */
  @Input() codeFilePath: string;

  /** ä»£ç ç¼è¾å¨å¤å£³ç»ä»¶å®ä¾ */
  @ViewChild('codeEditor') codeEditor: MonacoCodeEditorComponent;

  /** ä»£ç æ´æ¹äºä»¶ */
  @Output() codeChanged = new EventEmitter<ChangeInfo>(true);

  /** è®°å½ä»£ç æ¯å¦æ´æ¹è¿ */
  isCodeChanged: boolean = false;

  private SAVE_SUCCESS_TIP = 'ä¿å­æå';

  /** è®°å½ç»ä»¶åè®¢éï¼Destroyæ¶åæ¶è®¢é */
  private subscriptions: Subscription[] = [];

  constructor(
    private componentCodeService: ComponentCodeService,
    private loadingService: LoadingService,
    private messageService: MessagerService,
    private messageNotifyService: MessageNotifyService
  ) {
  }

  ngOnInit() {
    LogUtil.info('ä»£ç ç¼è¾å¨ç»ä»¶init');
  }

  ngAfterViewInit(): void {
    // æ³¨åä»£ç æ´æ¹äºä»¶
    this.codeEditor.onOutlineChanged((path: string, changeInfo: ChangeInfo) => {
      LogUtil.info('ä»£ç æ´æ¹äºä»¶ï¼', changeInfo);
      this.isCodeChanged = changeInfo.changed;
      this.codeChanged.emit(changeInfo);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.codeFilePath && changes.codeFilePath.currentValue) {
      LogUtil.info(`æä»¶ä»£ç è·¯å¾ï¼${this.codeFilePath}`);
      this.isCodeChanged = false;
      this.openIDE();
    }
  }

  /**
   * æå¼ä»£ç ç¼è¾å¨
   */
  private openIDE(closeLoadingService?: boolean): void {
    if (!this.codeFilePath) {
      LogUtil.error('ä»£ç ç¼è¾å¨æå¼å¤±è´¥ï¼ä»£ç æä»¶è·¯å¾ä¸ºç©º');
      return;
    }
    this.reloadCode().subscribe(() => {
      if (closeLoadingService) {
        this.loadingService.close();
      }
    }, (err) => {
      if (closeLoadingService) {
        this.loadingService.close();
      }
      this.messageNotifyService.showRequestErrorMessage(err);
      throw new Error(err);
    });
  }


  /**
   * éæ°è¯»åä»£ç å·æ°
   */
  public reloadCode(): Observable<string> {
    return this.componentCodeService.get(this.codeFilePath).pipe(map(data => {
      const code = data;
      this.codeEditor.open(this.codeFilePath, code)
        .catch((err) => { LogUtil.error('æå¼ä»£ç ç¼è¾å¨åºé', err); });
      return data;
    }));
  }

  /**
   * æ£æ¥è·åä»£ç åæ¬å°æä»¶æ¯å¦è¢«æ´æ¹è¿
   * è¥æ´æ¹è¿åæç¤ºç¨æ·è¿è¡ä¸åå¤ç
   */
  public checkCodeVersion(): void {
    if (!this.isCodeChanged) {
      this.loadingService.show();
      this.openIDE(true);
      return;
    }
    this.loadingService.show();
    this.componentCodeService.isFileModified(this.codeFilePath).subscribe(
      (data: ModificationInfo) => {
        this.loadingService.close();
        if (data.isModified) {
          // éæ°è·åæä»¶å¹¶ä¸å³é­loadingæå¡
          this.messageService.question('æ¬å°Javaæä»¶å·²è¢«æ´æ¹ï¼éè¦éæ°è¯»åï¼è¿å°ä¸¢å¤±æ¨å½åæªä¿å­çä»£ç ï¼æ¯å¦ç»§ç»­ï¼',
            () => {
              this.loadingService.show();
              this.openIDE(true);
            },
            () => {
              this.messageService.warning('å¨çº¿ä»£ç ä¸æ¬å°Javaæä»¶ä¸­ä»£ç çæ¬ä¸ä¸è´ï¼è¯·éæ°è¯»åä»£ç ååç¼è¾ï¼å¦åæ æ³ä¿å­!');
            });
        }
      },
      (err) => {
        this.loadingService.close();
        this.messageNotifyService.showRequestErrorMessage(err);
      });
  }

  /**
   * éè¿æ¬å°IDEAæå¼ä»£ç å·¥ç¨å¹¶å®ä½è³æä»¶æä»¶
   */
  public openInIDEA(): void {
    this.loadingService.show();
    this.saveCode()
      .then((result: SaveResult) => {
        if (result.success) {
          this.componentCodeService.openCodeByIDEA(this.codeFilePath).subscribe(() => {
            this.loadingService.close();
            this.messageNotifyService.notify('æå¼IDEAæåï¼', NotifyType.SUCCESS);
          }, (error) => {
            this.loadingService.close();
            this.messageNotifyService.showRequestErrorMessage(error);
          });
        } else {
          this.loadingService.close();
          this.messageService.error('ä¿å­ä»£ç å¤±è´¥ï¼' + result.tip);
        }
      })
      .catch((err) => {
        this.loadingService.close();
        this.messageService.error('ä¿å­ä»£ç å¤±è´¥ï¼');
        LogUtil.error(err);
      });
  }

  /** ä¿å­ä»£ç  */
  public saveCode(): Promise<SaveResult> {
    return this.getCode().then((codeResult) => {
      const codeContent = codeResult.content;
      const saveResult = {} as SaveResult;
      return this.componentCodeService.save(this.codeFilePath, codeContent).toPromise().then(
        () => {
          this.codeEditor.save(this.codeFilePath, true);
          this.isCodeChanged = false;
          saveResult.success = true;
          saveResult.tip = this.SAVE_SUCCESS_TIP;
          return saveResult;
        }).catch((error) => {
          LogUtil.error(error);
          saveResult.success = false;
          saveResult.tip = this.messageNotifyService.getErrorMessage(error);
          return saveResult;
        });
    }).catch((error) => {
      const saveResult = {} as SaveResult;
      saveResult.success = false;
      saveResult.tip = 'è·åå½åä»£ç åºé';
      LogUtil.error(error);
      return saveResult;
    });
  }

  /**
   * è·åæä»¶è§£æç»æ
   * @param path - æä»¶è·¯å¾
   * @returns æä»¶åå®¹åç±»ç»æï¼å¦ææä»¶å°æªæå¼åè¿ånull
   */
  public getCode(): Promise<{
    content: string; hasFatalError?: boolean;
    classes?: IClass[];
  }> {
    return this.codeEditor.resolve(this.codeFilePath, true);
  }

  /**
   * è®¾ç½®ä¸»é¢
   * @param isDarkTheme æ¯å¦æ·±è²ä¸»é¢
   */
  public async setTheme(isDarkTheme: boolean): Promise<void> {
    return this.codeEditor.setTheme(isDarkTheme);
  }

  /**
   * ç»ä»¶éæ¯äºä»¶ï¼æ§è¡åæ¶è®¢é
   */
  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

}
